import React, { useEffect, useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
function CMSServiceMain() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const checkEKOonboardStatus = () => {
    if (profiledetail.eko_onboard_status == "0") {
      return true;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("300.6"));
  }, []);
  return (
    <div className="m-4">
      {" "}
      {memberServices.includes("105") && (
        <div className="grid grid-cols-1  md:grid-cols-3  place-items-start gap-3">
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              CMS
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("105")
                      ? "/eko/cms"
                      : "/not-available",
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">CMS</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default CMSServiceMain;
